import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cs from './app/i18n/locales/cs.json';
import en from './app/i18n/locales/en.json';
import hr from './app/i18n/locales/hr.json';
import hu from './app/i18n/locales/hu.json';
import sk from './app/i18n/locales/sk.json';

i18n.use(initReactI18next).init({
  resources: {
    cs: { project: cs },
    en: { project: en },
    hr: { project: hr },
    sk: { project: sk },
    hu: { project: hu },
  },
  fallbackLng: 'cs',
  ns: ['project'],
  defaultNS: 'project',
  interpolation: { escapeValue: false },
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
  });
}

export const t = i18n.t.bind(i18n);
export default i18n;
